// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"9795f510","236":"de2cf15f","283":"4dda71bb","289":"50230384","454":"01fbdf0e","494":"2531e515","656":"1e809524"}[chunkId] + ".chunk.css";
};